function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MonotoneChain from './MonotoneChain';
import Integer from '../../../../../java/lang/Integer';
import ArrayList from '../../../../../java/util/ArrayList';
import Quadrant from '../../geomgraph/Quadrant';
var MonotoneChainBuilder = /*#__PURE__*/function () {
  function MonotoneChainBuilder() {
    _classCallCheck(this, MonotoneChainBuilder);
    MonotoneChainBuilder.constructor_.apply(this, arguments);
  }
  return _createClass(MonotoneChainBuilder, [{
    key: "getClass",
    value: function getClass() {
      return MonotoneChainBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "getChainStartIndices",
    value: function getChainStartIndices(pts) {
      var start = 0;
      var startIndexList = new ArrayList();
      startIndexList.add(new Integer(start));
      do {
        var last = MonotoneChainBuilder.findChainEnd(pts, start);
        startIndexList.add(new Integer(last));
        start = last;
      } while (start < pts.length - 1);
      var startIndex = MonotoneChainBuilder.toIntArray(startIndexList);
      return startIndex;
    }
  }, {
    key: "findChainEnd",
    value: function findChainEnd(pts, start) {
      var safeStart = start;
      while (safeStart < pts.length - 1 && pts[safeStart].equals2D(pts[safeStart + 1])) {
        safeStart++;
      }
      if (safeStart >= pts.length - 1) {
        return pts.length - 1;
      }
      var chainQuad = Quadrant.quadrant(pts[safeStart], pts[safeStart + 1]);
      var last = start + 1;
      while (last < pts.length) {
        if (!pts[last - 1].equals2D(pts[last])) {
          var quad = Quadrant.quadrant(pts[last - 1], pts[last]);
          if (quad !== chainQuad) break;
        }
        last++;
      }
      return last - 1;
    }
  }, {
    key: "getChains",
    value: function getChains() {
      if (arguments.length === 1) {
        var pts = arguments[0];
        return MonotoneChainBuilder.getChains(pts, null);
      } else if (arguments.length === 2) {
        var _pts = arguments[0];
        var context = arguments[1];
        var mcList = new ArrayList();
        var startIndex = MonotoneChainBuilder.getChainStartIndices(_pts);
        for (var i = 0; i < startIndex.length - 1; i++) {
          var mc = new MonotoneChain(_pts, startIndex[i], startIndex[i + 1], context);
          mcList.add(mc);
        }
        return mcList;
      }
    }
  }, {
    key: "toIntArray",
    value: function toIntArray(list) {
      var array = new Array(list.size()).fill(null);
      for (var i = 0; i < array.length; i++) {
        array[i] = list.get(i).intValue();
      }
      return array;
    }
  }]);
}();
export { MonotoneChainBuilder as default };
MonotoneChainBuilder.constructor_ = function () {};